<template>
    <a :href="'#' + link">
        <img :style="cssStyle" :src="_.imgPath(initialValue, variant)" />
    </a>
</template>
<script>
import Vue from 'vue';

export default {
    data() {
        return {

        }
    },

    components: {

    },

    props: ['initialValue', 'css', 'config', 'data'],

    watch: {

    },

    computed: {
        variant() {
            const variant = _.get(this.config, 'variant');
            return variant;
        },
        link() {
            return this.helpers('uriFormat')(_.get(this.data, 'link', ''));
        },
        cssStyle() {
            return _.get(this.config, 'cssStyle', '');
        }
    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/ThumbnailComponent.vue